// React
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
// Utils
// Components
import ToppingBox from '../topping-box/ToppingBox'
// Styles
import useStyles from './MenuToppingsList.styles'

const getToppingBoxes = (
  classes,
  toppings,
  deactivatedItemId,
  setDeactivatedItemId,
) => {
  if (!toppings) {
    return null
  }

  return toppings.map((topping, index) => {
    return (
      <ToppingBox
        key={`t-${index}-${topping.id}`}
        classes={classes}
        topping={topping}
        deactivatedItemId={deactivatedItemId}
        setDeactivatedItemId={setDeactivatedItemId}
      />
    )
  })
}

const getToppingCategoriesComponent = (
  toppingBoxClasses,
  classes,
  toppingCategories,
  deactivatedItemId,
  setDeactivatedItemId,
) => {
  if (!toppingCategories || toppingCategories.length === 0) {
    return null
  }

  return toppingCategories.map((toppingCategory, index) => {
    const toppingBoxes = getToppingBoxes(
      toppingBoxClasses,
      toppingCategory.toppings,
      deactivatedItemId,
      setDeactivatedItemId,
    )
    return (
      <div
        className={classes.toppingCategoryContainer}
        key={`tc-${toppingCategory.id}-${index}`}
      >
        <div className={classes.toppingCategoryDescription}>
          <span>{toppingCategory.description}</span>
        </div>
        <div className={classes.toppingCategoryToppingsContainer}>
          {toppingBoxes}
        </div>
      </div>
    )
  })
}

const MenuToppingsList = ({ classes, title, toppingCategories }) => {
  const [deactivatedItemId, setDeactivatedItemId] = useState(null)
  const componentClasses = useStyles()

  const toppingBoxClasses = {
    root: classNames(componentClasses.toppingBoxRoot, classes.toppingBoxRoot),
  }

  const toppingCategoriesComponentClasses = {
    toppingCategoryContainer: classNames(
      componentClasses.toppingCategoryContainer,
      classes.toppingCategoryContainer,
    ),
    toppingCategoryDescription: classNames(
      componentClasses.toppingCategoryDescription,
      classes.toppingCategoryDescription,
    ),
    toppingCategoryToppingsContainer: classNames(
      componentClasses.toppingCategoryToppingsContainer,
      classes.toppingCategoryToppingsContainer,
    ),
  }
  const toppingCategoriesComponent = getToppingCategoriesComponent(
    toppingBoxClasses,
    toppingCategoriesComponentClasses,
    toppingCategories,
    deactivatedItemId,
    setDeactivatedItemId,
  )

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <div
        className={classNames(
          componentClasses.toppingsTitle,
          classes.toppingsTitle,
        )}
      >
        <span>{title}</span>
      </div>
      {toppingCategoriesComponent}
    </div>
  )
}

MenuToppingsList.propTypes = {
  toppingsGroups: PropTypes.array,
  onChangeToppingAvailability: PropTypes.func,
}
MenuToppingsList.defaultProps = {
  classes: {},
  toppingCategories: [],
}

export default MenuToppingsList
